import { FunctionComponent } from 'react'

import useSubscriptionStatus from '@hooks/useSubscriptionStatus'
import useURLParam from '@hooks/useURLParam'
import { CookWidget, JSONTypeForCookWidget } from '@widgets/types'

const OfferPageWithRecommendations: FunctionComponent = () => {
  const isMarketingLandingPage = useURLParam('mlp') === 'true'

  const { subscriptionStatus } = useSubscriptionStatus()
  const isSubscriber = subscriptionStatus === 'subscribed'

  return isMarketingLandingPage ? (
    <div className="marketing-landingpage-container" />
  ) : (
    <>
      <div className="offer-page-header-container" />
      {isSubscriber ? (
        <>
          <div className="piano-recommendations-container" />
          <div className="offer-page-reasons-container" />
        </>
      ) : (
        <>
          <div className="offer-page-reasons-container" />
          <div className="piano-recommendations-container" />
        </>
      )}
      <div className="offer-page-footer-container" />
    </>
  )
}

const widget = {
  kind: ['offer-page-with-recommendations'],
  component: OfferPageWithRecommendations,
} as const satisfies CookWidget

export type WidgetType = typeof widget

export type JSONWidgetType = JSONTypeForCookWidget<WidgetType>

export default widget
